import React from "react";
import { isMac } from "@clientUtils";
import TextFieldSR, { TextFieldSRProps } from "@components/TextFieldSR";

type Props = TextFieldSRProps & {
  onEnter?: (e: React.SyntheticEvent<any>) => void;
  onCtrlEnter?: (e: React.SyntheticEvent<any>) => void;
};

const CommentTextField: React.FC<Props> = (props) => {
  const { onEnter, onCtrlEnter, ...rest } = props;

  return (
    <TextFieldSR
      onKeyDown={(e) => {
        // submit if enter
        if (e.key === "Enter") {
          onEnter && onEnter(e);
        }

        if (e.key === "Enter" && (isMac() ? e.metaKey : e.ctrlKey)) {
          e.preventDefault();
          onCtrlEnter && onCtrlEnter(e);
        }
      }}
      fullWidth
      multiline
      {...rest}
    />
  );
};

export default CommentTextField;
